import React from "react"

import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { ColorName } from "@tenforce/toolbox-default-style"
import { Symbols } from "@tenforce/toolbox-fontmap"

import { GlobalState } from "../../../../store"
import { useAppSelector } from "../../../../hooks"

import { IRootCauseAnalysisActions } from "../.."

import ControlsContextMenu from "./ControlsContextMenu"

interface Props {
    actions: IRootCauseAnalysisActions
}

export const Controls = ({ actions }: Props): JSX.Element => {
    const {
        controls: {
            isCopyAllowed,
            isReadOnly,
            isFiveWhysEnabled,
            isIshikawaEnabled,
        },
        labels,
        findings,
    } = useAppSelector((state: GlobalState) => state.incidents)

    const canCopy = !!isCopyAllowed && findings.length > 0

    if (isReadOnly || (!isFiveWhysEnabled && !isIshikawaEnabled)) {
        return <></>
    }

    return (
        <div data-ft-component="rca-controls">
            {canCopy && (
                <Action
                    actionType={ActionType.button}
                    isTransparent={true}
                    textColor={ColorName.Goldenrod}
                    data-ft-component="copyAnalysis"
                    onClick={(): void => {
                        actions.copyAnalysis()
                    }}
                    title={labels.copyAnalysis}
                >
                    {Symbols.Reports} {labels.copyAnalysis}
                </Action>
            )}

            {isFiveWhysEnabled && (
                <Action
                    actionType={ActionType.button}
                    isTransparent={true}
                    textColor={ColorName.Goldenrod}
                    data-ft-component="addFiveWhysRCA"
                    onClick={(): void => {
                        actions.addFiveWhys(null)
                    }}
                    title={labels.addFiveWhysRCA}
                >
                    {Symbols.Create} {labels.addFiveWhysRCA}
                </Action>
            )}

            {isIshikawaEnabled && (
                <Action
                    actionType={ActionType.button}
                    isTransparent={true}
                    textColor={ColorName.Goldenrod}
                    data-ft-component="addIshikawaRCA"
                    onClick={(): void => {
                        actions.addIshikawa(null)
                    }}
                    title={labels.addIshikawaRCA}
                >
                    {Symbols.Create} {labels.addIshikawaRCA}
                </Action>
            )}

            <ControlsContextMenu actions={actions} />
        </div>
    )
}

export default Controls
